module.exports = __webpack_public_path__ + "static/media/4project.6410d280.jpg";